import Icon from '../../Icon/Icon'
import Typography from '../../Typography/Typography'

import './ButtonQuantity.scss'

const ButtonQuantity = ({ quantity, onClickLeft, onClickRight }) => {
    return (
        <div className="button-quantity btn rounded-0 bg-white d-flex justify-content-between">
            <Icon className={'button-quantity--img'} name={'minus-blue'} onClick={onClickLeft} />
            <div className="button-quantity--text d-flex">
                <Typography variant={'badge'} color={'magentaSecondary'} className={'mx-auto'}>
                    {quantity}
                </Typography>
            </div>
            <Icon className={'button-quantity--img'} name={'plus-blue'} onClick={onClickRight} />
        </div>
    )
}

export default ButtonQuantity
